module.exports = __webpack_public_path__ + "static/media/mockup.d13a8e42.png";